import React, { useState, useEffect } from 'react';
import '../css/CustomModal.css';

const useCustomModal = () => {
    const [modalConfig, setModalConfig] = useState({ isOpen: false, type: 'info', message: '', onClose: null, persist: false });

    // Utility: Show Custom Modal
    const showModal = (message, type = 'info', onClose = null, persist = false) => {
        setModalConfig({ isOpen: true, message, type, onClose, persist });
    };

    // Close Utility
    const closeModal = () => {
        if (modalConfig.onClose) modalConfig.onClose();
        setModalConfig({ ...modalConfig, isOpen: false });
    };

    // Global Key Listener for Modal
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (modalConfig.isOpen && !modalConfig.persist) {
                closeModal();
            }
        };

        if (modalConfig.isOpen && !modalConfig.persist) {
            window.addEventListener('keydown', handleKeyDown);
        }
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [modalConfig]);

    const CustomModalComponent = () => {
        if (!modalConfig.isOpen) return null;

        return (
            <div className="custom-modal-overlay" onClick={() => {
                if (!modalConfig.persist) closeModal();
            }}>
                <div className="custom-modal-content" onClick={e => e.stopPropagation()}>
                    {(modalConfig.type === 'spinner') ? (
                        <>
                            <div className="spinner-border text-danger mt-2" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <h5 className="mt-3">{modalConfig.message}</h5>
                            <p className="text-muted small mt-2">Please wait...</p>
                        </>
                    ) : (
                        <>
                            <div className={`modal-icon ${modalConfig.type}`}>
                                {modalConfig.type === 'success' && <i className="fa fa-check-circle text-success"></i>}
                                {modalConfig.type === 'error' && <i className="fa fa-times-circle text-danger"></i>}
                                {modalConfig.type === 'warning' && <i className="fa fa-exclamation-triangle text-warning"></i>}
                                {modalConfig.type === 'info' && <i className="fa fa-info-circle text-info"></i>}
                            </div>
                            <h4 className="mt-3">{modalConfig.type === 'error' ? 'Error' : modalConfig.type === 'success' ? 'Success' : 'Notice'}</h4>
                            <p className="modal-message mt-2">{modalConfig.message}</p>
                            {!modalConfig.persist && <p className="text-muted small mt-4 mb-0">(Press any key or click to close)</p>}
                        </>
                    )}
                </div>
            </div>
        );
    };

    return { showModal, closeModal, CustomModalComponent, isModalOpen: modalConfig.isOpen };
};

export default useCustomModal;
